module.exports = __webpack_public_path__ + "img/product_88.6d8eb42.webp";